/* eslint-disable no-bitwise, global-require */
import dbg from 'debug';

const debug = dbg('jp:analytics');

let instance = null;

const prodConfig = {
  AdWords: {
    conversionId: '1065433872'
  },
  'Facebook Pixel': {
    pixelId: '540636262740875'
  },
  'Google Analytics': {
    trackingId: 'UA-11508076-1'
  },
  Mixpanel: {
    consolidatedPageCalls: false,
    token: '227ff3f622bc8de131254686178755ca',
    trackNamedPages: true,
    crossSubdomainCookie: true,
    eventIncrements: [],
    legacySuperProperties: false,
    people: false,
    peopleProperties: [],
    persistence: 'cookie',
    propIncrements: [],
    secureCookie: false,
    setAllTraitsByDefault: true,
    superProperties: [],
    trackAllPages: false,
    trackCategorizedPages: true
  },
  'Twitter Ads': {
    page: 'l4swr'
  }
};

const stagingConfig = {
  AdWords: { conversionId: '1065433872' },
  'Facebook Pixel': { pixelId: '540636262740875' },
  'Google Analytics': { trackingId: 'UA-11508076-6' },
  Mixpanel: {
    consolidatedPageCalls: false,
    crossSubdomainCookie: true,
    eventIncrements: [],
    legacySuperProperties: false,
    people: false,
    peopleProperties: [],
    persistence: 'cookie',
    propIncrements: [],
    secureCookie: false,
    setAllTraitsByDefault: true,
    superProperties: [],
    trackAllPages: false,
    trackCategorizedPages: true,
    token: 'aa8496acc07d2a32659aa70607c65302',
    trackNamedPages: true
  },
  'Twitter Ads': { page: 'l4swr' }
};

if (__CLIENT__) {
  window.jpAnalyticsConfig =
    process.env.NODE_ENV === 'production' ? prodConfig : stagingConfig;
}

export default class Analytics {
  constructor() {
    if (instance) {
      return instance;
    }

    if (!instance && __CLIENT__ && process.env.NODE_ENV !== 'test') {
      const analytics = require('jp-analytics');
      this.tracking = analytics(process.env.JP_ANALYTICS_CLIENT_ID, {
        JustPark: {
          baseUrl: process.env.JP_ANALYTICS_URL
        }
      });

      if (typeof this.tracking.ready === 'function') {
        this.tracking.ready(() => {
          // Do any other setup required
          debug('ready');
        });
      }

      instance = this;
      return instance;
    }

    return {
      page: () => {},
      identify: () => {},
      track: () => {},
      reset: () => {}
    };
  }

  identify(userId = '', traits = {}, options = {}, callback = () => {}) {
    debug('identify', { userId, traits, options });
    return (
      this.tracking && this.tracking.identify(userId, traits, options, callback)
    );
  }

  track(event, properties = {}, options = {}, callback = () => {}) {
    debug('event', { properties, options });
    const props = { ...properties, date: ~~(Date.now() / 1000) };
    return (
      this.tracking && this.tracking.track(event, props, options, callback)
    );
  }

  page(name = '', properties = {}, options = {}) {
    debug('page', { name, properties, options });
    const props = { ...properties, date: ~~(Date.now() / 1000) };
    return this.tracking && this.tracking.page(name, props, options);
  }

  reset() {
    debug('reset');
    if (__CLIENT__) {
      this.tracking.reset();

      if (window.mixpanel) {
        window.mixpanel.reset();
      }
    }
  }
}
